import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import { Row, Col } from 'react-flexa';
import { ThemeProvider } from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import NavbarItem from './NavbarItem';
import SearchBar from './SearchBar';
import Sidebar from './Sidebar';
import { flexaTheme, navbarItems } from '../helpers';
import Image from '../../components/Image';

const styles = theme => ({
  root: {
    width: '100%',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      height: 72
    }
  },
  row: {
    width: '100%',
    height: '100%'
  },
  navbar: {
    alignItems: 'stretch',
    maxHeight: 80,
    width: '90%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    maxWidth: 1360,
    padding: 0,
    alignSelf: 'center'
  },
  navbarNav: {
    display: 'flex',
    listStyleType: 'none',
    margin: 0,
    marginRight: -90,
    width: '100%',
    padding: 0,
    zIndex: 1
  },
  divider: {
    width: 2,
    height: 28,
    margin: 4,
    alignSelf: 'center'
  },
  button: {
    alignSelf: 'center',
    padding: '.4rem 1.5rem',
    border: `1.69px solid ${theme.palette.primary.main}`,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      color: '#fff'
    },
    margin: 'auto'
  },
  mobileButton: {
    alignSelf: 'right',
    textAlign: 'center',
    padding: '.4rem .6rem',
    border: `1.69px solid ${theme.palette.secondary.dark}`,
    '&:hover': {
      borderColor: theme.palette.secondary.dark,
      backgroundColor: theme.palette.secondary.dark,
      color: '#fff'
    },
    margin: 'auto',
    [theme.breakpoints.down('321')]: {
      lineHeight: 1
    }
  },
  buttonLabel: {
    fontWeight: 'bold'
  },
  signInButton: {
    alignSelf: 'center',
    textTransform: 'none',
    margin: 'auto',
    '&:hover': {
      color: theme.palette.primary.main
    }
  }
});

class Navbar extends React.Component {
  state = {
    showSearchBar: false,
    showSidebar: false,
    buttonHover: false
  };

  handleProfileMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };

  handleMobileMenuOpen = event => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };

  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };

  toggleSearchBar = (showSearchBar, callback) => {
    this.setState({ showSearchBar }, callback);
  };

  toggleSidebar = showSidebar => e => {
    this.setState({ showSidebar });
  };

  toggleButtonHover = buttonHover => e => {
    this.setState({ buttonHover });
  };

  render() {
    const { classes, signInUrl, handleClick } = this.props;
    const { buttonHover, showSearchBar, showSidebar } = this.state;

    return (
      <ThemeProvider theme={flexaTheme}>
        <div className={classes.root}>
          <AppBar position="static" color="inherit" style={{ height: '100%' }}>
            <Toolbar className={`${classes.navbar} toolbar-padding-sm`}>
              <Row className={classes.row} gutter={'.5rem'}>
                <Col xs={0} sm={0} md={2} lg={1.5} display="flex">
                  <a href="/" style={{ alignSelf: 'center' }}>
                    <Image
                      className="dbuy-logo"
                      src="/homepage/direct-black-logo.svg"
                      width="100%"
                    />
                  </a>
                </Col>
                <Col
                  xs={0}
                  sm={0}
                  md={6.5}
                  lg={7}
                  display="flex"
                  style={{ justifyContent: 'flex-end' }}
                >
                  {!showSearchBar && (
                    <ul className={classes.navbarNav}>
                      {navbarItems.map((props, i) => (
                        <NavbarItem key={i} {...props} />
                      ))}
                    </ul>
                  )}
                  <SearchBar
                    show={showSearchBar}
                    toggleSearchBar={this.toggleSearchBar}
                  />
                  <Divider className={classes.divider} />
                </Col>
                <Col xs={0} sm={0} md={3.5} display="flex">
                  <Button
                    classes={{ label: `${classes.buttonLabel} navbar-item` }}
                    className={`${classes.button}`}
                    color="primary"
                    component="a"
                    onClick={handleClick}
                    variant={buttonHover ? 'contained' : 'outlined'}
                    onMouseOver={this.toggleButtonHover(true)}
                    onMouseLeave={this.toggleButtonHover(false)}
                  >
                    Become a Member
                  </Button>
                  <Button
                    color="primary"
                    component="a"
                    className={`${classes.signInButton} navbar-item`}
                    href={signInUrl}
                  >
                    Sign&nbsp;In&nbsp;&rsaquo;
                  </Button>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={0}
                  display="flex"
                  style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      paddingLeft: 10,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignSelf: 'left',
                      zIndex: 1
                    }}
                  >
                    <div style={{ display: 'flex', paddingRight: 30 }}>
                      <a href="/" style={{ alignSelf: 'center' }}>
                        <Image
                          className="dbuy-logo"
                          src="/homepage/direct-black-logo.svg"
                          width="100%"
                          style={{ maxWidth: 150 }}
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    style={{
                      paddingRight: 10,
                      display: 'flex',
                      alignSelf: 'right'
                    }}
                  >
                    <Button
                      classes={{ label: `${classes.buttonLabel} navbar-item` }}
                      className={`${classes.mobileButton}`}
                      color="default"
                      component="a"
                      onClick={handleClick}
                      variant={buttonHover ? 'contained' : 'outlined'}
                      onMouseOver={this.toggleButtonHover(true)}
                      onMouseLeave={this.toggleButtonHover(false)}
                    >
                      Become a Member
                    </Button>
                  </div>
                  <IconButton
                    style={{ paddingRight: 0 }}
                    onClick={this.toggleSidebar(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Col>
              </Row>
            </Toolbar>
          </AppBar>
          <Sidebar show={showSidebar} toggleSidebar={this.toggleSidebar} />
        </div>
      </ThemeProvider>
    );
  }
}

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default withStyles(styles)(Navbar);
